import { Injectable } from '@angular/core';
import { HttpClient,HttpParams } from '@angular/common/http';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { Onlineservices,GetFare,FareCalculation,GetRouteByStation,FareCalculationUnLtd,GetFrequencyByType,GetPassHistory, InsertPassRenew, InsertPassNew } from './onlineservices';
import { Result } from 'src/app/shared/result';
import { environment } from 'src/environments/environment';
import { dateFieldName } from '@progress/kendo-angular-intl';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OnlineserviceService {
  private header = 'Content-Type';
  private headerValue = 'application/json';
  getlen: string;
  token:string;
  userid: number;
  constructor(private http: HttpClient) { 
    this.getlen = LocalstorageService.getLanguage("language");
    this.userid = Number(LocalstorageService.getLocal('user_NMC'));
    this.token = LocalstorageService.getLocal('token');
  }

  public InitHeader()
  {
   let headers;
  //  if(this.token)
  //  {
    let token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImFkbWluIiwibmJmIjoxNjI0NjIxNzk5LCJleHAiOjE2MjQ3MDgxOTksImlhdCI6MTYyNDYyMTc5OSwiaXNzIjoiNzVmMm8xZDhiMzcyNzRxOTA5MFNiMzM3NTkxYWJkM2U0NDQ1M2I5NSIsImF1ZCI6Ijc1ZjJvMWQ4YjM3Mjc0cTkwOTBTYjMzNzU5MWFiZDNlNDQ0NTNiOTUifQ.DvursLikIo4QG0GsgTv9o7pqel5aqVKuTNZDHmeSKk4";
     headers = { 
      // 'Authorization': 'Bearer ' + token, 
      //  'Postman-Token':'<calculated when request is sent>',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Access-Control-Allow-Methods':'*',
      'Access-Control-Allow-Headers': 'Content-Type, Authorization',
      // 'Content-Length': '<calculated when request is sent>', 
      // 'Host':'<calculated when request is sent>'  ,
      'Accept':'*/*'
    };
   //} 
   return headers;
  }

  public GetPassDurationList() {
    let headers;
    // headers = this.InitHeader();
    //return this.http.post<Result>(`${environment.AFCSAPIURL}/api/SmartCard/GetCardsDetailsByRequestedUser`,data , { headers,withCredentials:true });    
    // return this.http.post<Result>(`${environment.AFCSAPIURL}/Nasik_MobileAPI/DigitalPass_V4/GetAllAvailableDurationAndFrequency`,null); 
    return this.http.post(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetAllAvailableDurationAndFrequency`,null);   
  }

  public GetPassDurationListByType(data:GetFrequencyByType) {
    let headers;
    // headers = this.InitHeader();
    // return this.http.post<Result>(`${environment.AFCSAPIURL}/Nasik_MobileAPI/DigitalPass_V4/GetDurationAndFrequency`,data); 
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetDurationAndFrequency`,data);   
  }


  public InsertPassDetails_old(data: Onlineservices){
    data.Username ="abcd!@#%^&*()_123"; 
    data.Password ="s@1_Dx*7s";
    let headers;
    headers = this.InitHeader();
    // return this.http.post<Result>(`${environment.AFCSAPIURL}/Nasik_MobileAPI/DigitalPass_V4/InsertPassTransaction`,data); 
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/InsertPassTransaction`, data); 
  }

  public GetPassconfigurationByType(intPassTypeID)
  {
   
    let params = new HttpParams();
    params = params.append('intPassTypeID', intPassTypeID);
    let headers;
    headers = this.InitHeader();
    // return this.http.get<Result>(`${environment.AFCSAPIURL}/Nasik_MobileAPI/DigitalPass_V4/GetPassConcessionDetailsByPassType?intPassTypeID=`+intPassTypeID); 
    return this.http.get<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetPassConcessionDetailsByPassType?intPassTypeID=`+intPassTypeID+'&lan='+this.getlen); 
  }

  public GetPassFareCalculation(body:any)
  {
    // const head = new HttpHeaders().set(this.header, this.headerValue);;
    let header = this.InitHeader();
    // head = 
    //data = JSON.stringify(data);
    // let head = new HttpHeaders().set(headers);
    debugger;
  //   var data = {
  //     intHHTicketCategoryID: 1,
  // intPassFrequencyID: 3,
  // intPassMediaID: 3,
  // intPassTypeID: 2,
  // intServiceTypeID: 1
  // }
    // return this.http.post<Result>(`https://ctusmartcardandsmartpassapidev.amnex.com/api/SmartCard/GetSmartCardApplicationRequestDetails`,data , { headers:header,withCredentials:true });  
    // return this.http.post(`${environment.AFCSAPIURL}/Nasik_MobileAPI/DigitalPass_V4/GetPassTotalFare`,body,{headers: header}); 
    return this.http.post(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetPassTotalFare`,body,{headers: header}); 
  }

  public GetRouteListByStation(data:GetRouteByStation)
  {
    data.lan = this.getlen;
    return this.http.post<Result>(`${environment.apiUrl}/Transistservice/GetRouteDetailsForPass_v1_Testing`, data); 
  }
  public GetPassHistory(data:GetPassHistory) {
    let headers;
    data.Username ="abcd!@#%^&*()_123"; 
    data.Password ="s@1_Dx*7s";
    data.lan = this.getlen;
    // headers = this.InitHeader();
    //return this.http.post<Result>(`${environment.AFCSAPIURL}/api/SmartCard/GetCardsDetailsByRequestedUser`,data , { headers,withCredentials:true });    
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetUserPassHistory`,data); 
    //return this.http.post(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetAllAvailableDurationAndFrequency`,null);   
  }
  public GetPassList(mob:string)
  {
    var data=null;
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetPassListByMobile?strMobileNo=`+mob,data); 
//    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetPassListByMobile?strMobileNo=`+mob,data); 

  }

  public GetPassDetailsByPassNo(passNo:number)
  {
    var data=null;
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetPassDetailsByPassNo?intPassNo=`+passNo,data); 
//    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/GetPassListByMobile?strMobileNo=`+mob,data); 

  }
  public InsertPassRenew(data: InsertPassRenew){
    debugger;
    data.Username ="abcd!@#%^&*()_123"; 
    data.Password ="s@1_Dx*7s";
    let headers;
    headers = this.InitHeader();
    // return this.http.post<Result>(`${environment.AFCSAPIURL}/Nasik_MobileAPI/DigitalPass_V4/InsertPassTransaction`,data); 
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/InsertPassTransactionForRenewal`, data); 
  }

  public InsertPassDetails(data){
    return this.http.post<Result>(`${environment.AFCSAPIURL}/api/DigitalPass_V4/InsertPassTransaction_New`, data); 
  }
}
